let _target;
let _rect;
let _text;
let _extent;
let _doc = document.documentElement; // IE

class Tooltip extends React.Component {
  constructor(props) {
    super(props);

    let rect = { top: 0, left: 0, width: 0, height: 0 };

    this.show = this.show.bind(this);
    this.hide = this.hide.bind(this);

    this.state = {
      visible: false,
      text: "",
      targetRect: rect,
      tipRect: rect
    };
  }

  _show(evt) {
    let target = evt.target;
    let top;
    let left;
    let right;
    let width;
    let height;
    let node;

    if (_target) {
      if (_target.contains && _target.contains(target)) {
        return;
      }

      if (_target !== target) {
        this._hide();
      }
    }

    if (target.getAttribute) {
      _text = target.getAttribute("data-tooltip");
    }

    if (_text) {
      _rect = target.getBoundingClientRect();

      _extent = {
        left: 0,
        right: window.innerWidth
      };

      top = _rect.top + (window.scrollY || _doc.scrollTop);
      left = Math.max(_extent.left, _rect.left + (window.scrollX || _doc.scrollLeft));
      right = Math.min(_extent.right, _rect.right);
      width =  right - left;
      height = _rect.height;

      node = ReactDOM.findDOMNode(this);

      this.setState({
        text: _text,
        orient: _rect.top > 50 ? "top" : "bottom",
        align: left > window.innerWidth - 65 && _text.length > 5 ? "right" : "center",
        targetRect: {
          top: top,
          left: left,
          width: width,
          height: height
        }
      }, function () {
        this.setState({
          tipRect: node.getBoundingClientRect(),
          visible: true
        });
      });

      _target = target;
    }
  }

  _hide(evt) {
    _target = null;

    this.setState({
      visible: false
    });
  }

  show(target) {
    this._show({ target });
  }

  hide() {
    if (this.state.visible) {
      this._hide();
    }
  }

  componentDidMount() {
    document.addEventListener("mouseover", this._show.bind(this));
    document.addEventListener("click", this._hide.bind(this));
    document.addEventListener("scroll", this._hide.bind(this));
  }

  componentWillUnmount() {
    document.removeEventListener("mouseover", this._show.bind(this));
    document.removeEventListener("click", this._hide.bind(this));
    document.removeEventListener("scroll", this._hide.bind(this));
  }

  render() {
    let { targetRect, tipRect, orient, align, text, visible } = this.state;
    let offsets = {};
    let style = {};

    if (visible) {
      offsets = {
        top: -tipRect.height - 10,
        bottom: targetRect.height + 10,
        center: (targetRect.width - tipRect.width) / 2,
        right: -tipRect.width + 34
      };

      style.opacity = 1;
      style.top = targetRect.top + offsets[orient];
      style.left = targetRect.left + offsets[align];
    }
    else {
      style.opacity = 0;
      style.top = 0;
      style.left = 0;
    }

    return (
      <div
        style={style}
        className="mc-screen mc-tooltip"
        data-orient={orient}
        data-align={align}
        role="tooltip"
        aria-hidden={!visible}>
          {text}
      </div>
    );
  }
}

module.exports = Tooltip;